import GenericFooter from "../../projects/generic/components/GenericFooter";

export default function MagicWareFooter() {
    return <GenericFooter companyName="MagicWare" companyUrl="https://www.magicare.cz" email="info@magicware.cz" />;
}
